module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073d9_logo_200x200.54e83aee.png";